"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { AlertCircle } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

export default function AuthError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/50 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Image src="/xd-logo-blue.svg" alt="Sjálfstæðisflokkurinn" width={98} height={66} unoptimized className="h-12 w-auto mx-auto" />
        </div>

        <div className="bg-card border border-border p-8 text-center">
          <AlertCircle className="w-10 h-10 text-destructive mx-auto mb-4" />
          <h1 className="text-xl font-heading font-bold text-foreground">
            Villa við auðkenningu
          </h1>
          <p className="text-sm text-muted-foreground mt-2">
            Óvænt villa kom upp. Vinsamlegast reyndu að skrá þig inn aftur.
          </p>
          {error.digest && (
            <p className="text-xs text-muted-foreground font-mono mt-3">
              Tilvísun: {error.digest}
            </p>
          )}
          <div className="flex gap-3 justify-center mt-6">
            <button
              onClick={() => reset()}
              className="xd-btn xd-btn-primary"
            >
              Reyna aftur
            </button>
            <Link href="/login" className="xd-btn xd-btn-ghost">
              Til baka á innskráningu
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
